export { deepMerge } from './utils'


// WEBPACK FOOTER //
// ./src/util/index.js